import styled from '@emotion/styled'
import { breakpoints, Grid, palette, spacing, Text, typography } from 'main/ui'

export const MainContainer = styled(Grid)`
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1)),
    url(https://ucarecdn.com/be48ffdd-a847-4a14-8837-daeeac08569f/MaskGroup.png);
  padding-top: ${spacing.majorScale(6)}px;
`

export const PhoneImageContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Title = styled(Text)`
  display: block;
  font-size: ${typography.fontSize.title.normal};
  font-weight: ${typography.fontWeight.bold};
  margin-bottom: ${spacing.minorScale(5)}px;
`

export const IntroText = styled(Text)`
  display: block;
  margin-bottom: ${spacing.minorScale(5)}px;
`

export const FeaturesList = styled.ul`
  padding: ${spacing.majorScale(2)}px;
  list-style: none;
`

export const ListItem = styled.li`
  margin-bottom: ${spacing.majorScale(2)}px;
  &:before {
    content: '•';
    color: ${palette.lightGray};
    font-weight: ${typography.fontWeight.bold};
    display: inline-block;
    width: ${spacing.majorScale(2)}px;
    margin-left: -${spacing.majorScale(2)}px;
  }
`

export const BoldText = styled(Text)`
  font-weight: ${typography.fontWeight.bold};
`
export const AppButton = styled.img`
  cursor: pointer;
  @media (min-width: ${breakpoints.lg}px) {
    margin-right: ${spacing.majorScale(4)}px;
  }
`

export const MobileAppButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`
